module.exports = __webpack_public_path__ + "9c13bc2165573ed15d39487a7d5cdc4e.aac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sonnen.aac
// module id = 255
// module chunks = 0